import Image from 'next/image';

import facebook from './assets/facebook.svg';
import globe from './assets/globe.svg';
import instagram from './assets/instagram.svg';
import leftArrow from './assets/left-arrow.svg';
import rightArrow from './assets/right-arrow.svg';
import spotify from './assets/spotify.svg';
import twitter from './assets/twitter.svg';
import upload from './assets/upload.svg';

export type IconButtonType =
  | 'spotify'
  | 'upload'
  | 'facebook'
  | 'globe'
  | 'instagram'
  | 'leftArrow'
  | 'rightArrow'
  | 'twitter';

export type IconButtonProps = {
  type: IconButtonType;
  floating?: boolean;
  onClick?: () => unknown;
};

function getIconImageFromType(type: IconButtonType) {
  switch (type) {
    case `spotify`: {
      return spotify;
    }
    case `upload`: {
      return upload;
    }
    case `facebook`: {
      return facebook;
    }
    case `globe`: {
      return globe;
    }
    case `instagram`: {
      return instagram;
    }
    case `leftArrow`: {
      return leftArrow;
    }
    case `rightArrow`: {
      return rightArrow;
    }
    case `twitter`: {
      return twitter;
    }
  }

  return ``;
}

const IconButton = (props: IconButtonProps) => {
  const { type, onClick, floating } = props;

  if (floating) {
    return (
      <button
        className={`flex h-[48px] w-[48px] items-center justify-center rounded-[14px] border border-gray-10 bg-[rgba(0,0,0,0.6)]`}
        onClick={onClick}
      >
        <Image
          width={20}
          height={20}
          src={getIconImageFromType(type)}
          alt={type}
        />
      </button>
    );
  }

  return (
    <button
      className={`flex h-[48px] w-[48px] items-center justify-center rounded-[14px] bg-gray-10`}
    >
      <Image
        width={20}
        height={20}
        src={getIconImageFromType(type)}
        alt={type}
      />
    </button>
  );
};

export default IconButton;
